// internal
import { axios, def, handleError, handleResponse } from './internal';

function R2Upload(bucket, data, onSuccess, service, fixedKey) {
    axios
        .post('/api/r2_upload', {
            bucket,
            data,
            service,
            ...(fixedKey && { fixedKey }),
        })
        .then((res) => {
            switch (res.data.code) {
                case def.ErrorCode.OK:
                    const { key } = res.data.data;
                    onSuccess?.(key);
                    break;
                default:
                    handleResponse(res);
                    break;
            }
        })
        .catch((err) => {
            handleError(err);
        });
}

export { R2Upload };
